import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import './assets/css/index.scss'
import './utils/rem.js'
// import loading from './utils/loading.js'
import router from './router'
import store from './store'
import storeLocal from 'storejs';
import FastClick from 'fastclick'
import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'
import {Mixin} from './utils/mixin/index'
import BtnPermission from './core/directives/btnPermission'
import {
    ActionSheet,
    Button,
    Cell,
    CellGroup,
    Circle,
    DatetimePicker,
    Divider,
    Field,
    Form,
    List,
    Loading,
    Picker,
    Popup,
    PullRefresh,
    Toast,
    Uploader
} from 'vant';
import 'vant/lib/button/style';
import 'vant/lib/uploader/style';
import dayjs from 'dayjs'
import { Image as VanImage } from 'vant';
import { install } from 'vs-tree'
import 'vs-tree/dist/vs-tree.css'
import moment from "moment";
Vue.prototype.dayjs = dayjs;
Vue.config.productionTip = false;
Vue.prototype.$storeLocal = storeLocal;
Vue.prototype.$bus = new Vue()
Vue.prototype.moment = moment
FastClick.attach(document.body);
Vue.use(AlloyFingerPlugin, {
    AlloyFinger
});
Vue.mixin(Mixin);
Vue.mixin(BtnPermission);
Vue.use( Toast);
Vue.use( Button);
Vue.use( Uploader);
Vue.use( Loading);
Vue.use( DatetimePicker );
Vue.use( Circle );
Vue.use( CellGroup );
Vue.use( Cell );
Vue.use( Popup );
Vue.use( Divider );
Vue.use( Form );
Vue.use( Field );
Vue.use( Picker );
Vue.use( PullRefresh );
Vue.use( List );
Vue.use(VanImage);
Vue.use(ActionSheet);
Vue.use(install);


Vue.component('MyTop', () => import('./components/myTop'));
// router.beforeEach((to, from, next) => {
// 	loading.show();
// 	next();
// })

Vue.directive('noEmoji',{
    inserted: function (el) {
        const input = el.querySelectorAll('#valueInputEmoji');
        var regRule = /[^u4E00-u9FA5|d|a-zA-Z|rns,.?!，。？！…—&$=()-+/*{}[]]|s/g
        input.onkeyup = function (e) {
            input.value = input.value.replace(regRule, '')
        };
        input.onblur = function (e) {
            input.value = input.value.replace(regRule, '')
        }
    }
});

if(process.env.NODE_ENV !== 'production') {
    var vConsole = new window.VConsole();
    // 接下来即可照常使用 `console` 等方法
    console.log('初始化成功');
    // 结束调试后，可移除掉
    vConsole.destroy();
}

// router.afterEach((to, from) => {
//     loading.hide();
// })
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
